module.exports=function(scope){ return `<!-- enrollmentIdentifier or FaceMap missing in request -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "This endpoint requires valid 'enrollmentIdentifier' or 'faceMap' parameters to be passed.",
        "subCode": "missingParameter"
    }
}

<!-- sessionId missing in request -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "The request is missing the sessionId parameter. The sessionId parameter is required and can be obtained from the output of the FaceTec iOS/Android/Browser SDK. For more information, please visit https://dev.facetec.com/zoomsdk/#/webservice-guide.",
        "subCode": "missingParameter"
    }
}

<!-- Invalid sessionId -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "sessionId must be UUID in standard format.",
        "subCode": "invalidSessionId"
    }
}

<!-- empty enrollmentIdentifier -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "Empty string not valid for parameter enrollmentIdentifier.",
        "subCode": "badStringParameter"
    }
}

<!-- empty faceMap -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "Empty string not valid for parameter FaceMap.",
        "subCode": "badStringParameter"
    }
}

<!-- faceMap is less then 20 characters -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "Source data length is < 20.",
        "subCode": "zoomServerRequestRejected",
    }
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/webservice-v2/response/failure/search.json.tpl